<template>
    <div>
    <Header />
        <div class="inner-wrapper">
            <div class="row" v-if="!$auth.isAuthenticated">  
                <div class="col-md-12 col-xl-7">  
                    <section class="panel">
                        <header class="panel-heading bg-primary">
                            <div class="panel-heading-icon">
                                <i class="fa fa-user-circle"></i>
                            </div>
                        </header>
                        <div class="panel-body text-left">
                            <h3 class="text-weight-semibold mt-sm text-center">Bienvenido al Portal de Clientes</h3>

                            <p>Para iniciar sesión haga click aquí:</p>                        
                            
                            <button @click="login">Iniciar Sesión</button>
                        </div>
                    </section>
                </div>
            </div>
            <div class="row" v-if="$auth.isAuthenticated">

                <div class="col-md-12 col-xl-7">
                    <Announcements />
                </div>
                <div class="col-md-12 col-xl-5">
                    <LastInvoice />
                </div>
                <div class="col-md-12 col-xl-5">
                    <PaymentMethods />
                </div>
                <!--<div class="col-md-12 col-xl-5">
                    <SupportInfoWidget />
                </div>-->
            </div>
                
        </div>
    </div>    
</template>

<script>
    import Announcements from '../components/Announcements.vue';
    import LastInvoice from '../components/LastInvoice.vue';
    import PaymentMethods from '../components/PaymentMethods.vue';
    import SupportInfoWidget from '../components/SupportInfoWidget.vue';
    import Header from '../components/Header.vue'
  export default {
    name : 'home',
    data : function() {
      return {
      }
    },
    components : {
        Header, Announcements, LastInvoice, PaymentMethods, SupportInfoWidget
    },
    methods: {
            // Log the user in
            login() {
                this.$auth.loginWithRedirect();
                },            
        }
  };
</script>